import { Menu, MenuItem } from '@mui/material';
import React from 'react';

type Option = {
  value: string;
  text: string;
  action: () => void;
  icon?: JSX.Element;
};

interface ISelectedMenuProps {
  isOpen: boolean;
  handleCloseMenu: () => void;
  anchorEl: HTMLElement | null;
  options: Option[];
  handleClick: (action: () => void) => void;
}

const minMenuWidth = 180;

const SelectedMenu: React.FC<ISelectedMenuProps> = ({ isOpen, anchorEl, handleCloseMenu, handleClick, options }) => {
  return (
    <div>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleCloseMenu}
        PaperProps={{
          style: {
            minWidth: minMenuWidth,
            borderRadius: '10px',
            boxShadow: '2px 2px 12px rgba(0, 0, 0, 0.12)',
          },
        }}
        disableScrollLock
      >
        {options.map(({ text, action, icon }: Option, idx) => (
          <MenuItem
            key={idx}
            onClick={() => handleClick(action)}
            sx={{
              display: 'flex',
              gap: '6px',
            }}
          >
            {icon}
            {text}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default SelectedMenu;
